// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App'
import { routes } from './routes.js'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'font-awesome/css/font-awesome.css'
import './assets/style/app.scss'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import { locales } from './locales/langs'
import qs from 'qs'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleLeft, faAngleRight, faSearch, faTimes, faBars, faSortDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ToggleButton from 'vue-js-toggle-button'
import VueAnalytics from 'vue-analytics'

library.add(faAngleLeft, faAngleRight, faSearch, faTimes, faBars, faSortDown)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', vSelect)
Vue.component('ToggleButton', ToggleButton)

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueAnalytics, {
  id: 'UA-78537321-8',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  },
  autoTracking: {
    pageviewOnLoad: false
  }
})

// Create VueI18n instance with options
let locale = window.localStorage.getItem('locale') || 'tw'
const i18n = new VueI18n({
  locale: locale,
  messages: locales
})

Vue.prototype.$qs = qs

const router = new VueRouter({
  base: 'LiveCampus',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (router.app.$store.getters.authorized && to.path === '/login') {
    next({ path: '/' })
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!router.app.$store.getters.authorized || !store.getters.authorized) {
      next({
        path: '/'
        // query: { redirect: to.fullPath }
      })
    } else {
      // already login
      next()
    }
  } else {
    if (to.path === '/' && router.app.$store.getters.authorized) {
      next({ path: '/home' })
    } else {
      next()
    }
  }
})

Vue.mixin({
  methods: {
    actionListener (action) {
      this[action.do](action.data)
    },

    goHome () {
      // for (var first in menu[this.$store.getters.userRole]) {
      //   break
      // }

      this.$router.push('/home')
    }
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  store,
  template: '<App/>',
  components: { App },
  i18n
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js